// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"4d93f088","357":"cbe1a857"}[chunkId] + ".chunk.css";
};